import { useQuery } from '@tanstack/react-query';

import fetchAdobeTestData from '~api/fetchAdobeTestData';

import { AdobeExperienceProps } from './AdobeABExperience';

type Props = {
    activity: string;
};

export default function AdobeABTest({ activity, children }: React.PropsWithChildren<Props>) {
    const { status, data } = useQuery({
        queryKey: ['adobetestdata'],
        queryFn: fetchAdobeTestData,
    });

    if (status !== 'success' || !data) {
        return null;
    }

    const theActivity = data.find(function findActivityByName(responseToken) {
        console.log('theActivity', responseToken['activity.name'], activity);
        return responseToken['activity.name'] === activity;
    });

    const experienceElements = (children as Array<string | React.ReactElement>)?.filter(
        (childNode) => {
            return (
                typeof childNode !== 'string' &&
                (childNode.type as React.JSXElementConstructor<AdobeExperienceProps>)?.name ===
                    'AdobeABExperience'
            );
        }
    ) as React.ReactElement<AdobeExperienceProps>[];
    console.log('experiences', experienceElements);

    const experienceName = theActivity?.['experience.name'];
    console.log('chosen experience:', experienceName);

    const renderedExperience = experienceElements.find((element) => {
        return !experienceName
            ? element.props.isdefault
            : element.props.experience === experienceName;
    });

    return renderedExperience || null;
}
